import { render, staticRenderFns } from "./IngredientCost.vue?vue&type=template&id=4488e0b4&scoped=true&"
import script from "./IngredientCost.vue?vue&type=script&lang=js&"
export * from "./IngredientCost.vue?vue&type=script&lang=js&"
import style0 from "./IngredientCost.vue?vue&type=style&index=0&id=4488e0b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4488e0b4",
  null
  
)

export default component.exports